import { Icon } from '@chakra-ui/react'
import { FiChevronDown } from 'react-icons/fi'

export function ChevronDown(props) {
  return <Icon as={FiChevronDown} {...props} />
}
